import React, { useEffect, useRef } from "react"
import { useRecoilValue } from "recoil"
import { selectedLayoutAtom } from "../Atoms/Layout"
import { currentPatientFileInfoAtom } from "../Atoms/PatientFile"
import { useModalProvider } from "../../../../../Providers/ModalProvider"
import { AnnotationGroupLoader } from "../Components/Modals/AnnotationGroupLoader/AnnotationGroupLoader"

// Prompt Annotation Setup once per open. A mount effect is too early on a
// cold page load — the layout selection atoms are still null until ToolBar's
// mount effect / Visualizations' render-phase defaults set them — so wait for
// the first render where a layout is actually selected before deciding.
export const useAnnotationSetupPrompt = () => {
	const { createModal } = useModalProvider()
	const selectedLayout = useRecoilValue(selectedLayoutAtom)
	const { isAdmitted } = useRecoilValue(currentPatientFileInfoAtom)
	const decided = useRef(false)

	useEffect(() => {
		if (decided.current || !selectedLayout) {
			return
		}

		decided.current = true

		if (!isAdmitted) {
			createModal(<AnnotationGroupLoader style={{ height: "80vh" }} />)
		}
	}, [createModal, isAdmitted, selectedLayout])
}
